// Module
var code = "<div ng-controller=\"CentrixSsoController\" class=\"panel full-height ir-dashboard-view\"> <iframe frameborder=\"0\" ng-src=\"{{url}}\" width=\"100%\" height=\"100%\" name=\"centrixIframe\" id=\"centrixIframe\" title=\"Centrix\"></iframe> </div> ";
// Exports
module.exports = code;